/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgOVY2TTEyIDIyQzguMTM0MDEgMjIgNSAxOC44NjYgNSAxNVY5QzUgNS4xMzQwMSA4LjEzNDAxIDIgMTIgMkMxNS44NjYgMiAxOSA1LjEzNDAxIDE5IDlWMTVDMTkgMTguODY2IDE1Ljg2NiAyMiAxMiAyMloiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";